"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationGuard = void 0;
var _react = _interopRequireDefault(require("react"));
var _auth0React = require("@auth0/auth0-react");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// import {PageLoader} from './page-loader'

const allowedRoles = ['User', 'Game Admin'];
const WithClaimCheck = (Component, claimCheckFunction, returnTo) => {
  const {
    user,
    isLoading
  } = (0, _auth0React.useAuth0)();
  if (isLoading) {
    return () => /*#__PURE__*/_react.default.createElement("div", null, "loading...");
  } else {
    if (claimCheckFunction(user)) {
      return Component;
    } else {
      return () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
        to: returnTo
      });
    }
  }
};
const checkClaims = user => {
  return user?.['https://games.uhnd.com/jwt/claims/role']?.some(role => allowedRoles.includes(role));
};
const AuthenticationGuard = ({
  component
}) => {
  const {
    user,
    getIdTokenClaims
  } = (0, _auth0React.useAuth0)();
  _react.default.useEffect(() => {
    async function getRoles() {
      await getIdTokenClaims();
    }
    getRoles();
  }, [getIdTokenClaims]);
  const Component = (0, _auth0React.withAuthenticationRequired)(WithClaimCheck(component, checkClaims, '/404'), {
    onRedirecting: () => /*#__PURE__*/_react.default.createElement("div", {
      className: "page-layout"
    }, "authenticating...")
  });
  return /*#__PURE__*/_react.default.createElement(Component, null);
};
exports.AuthenticationGuard = AuthenticationGuard;